module.exports = __webpack_public_path__ + "img/background020.dadbe759.jpg";